module.exports = "/images/01.svg?8ba802df5468ead326227bc57a8ebfb8";